import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class ConsultService {
  constructor(private request: Request, private http: HttpClient) { }

  getConsultsList(event): Observable<any> {
    if (event.direction == 'desc') {
      event.direction = 2;
    } else {
      event.direction = 1;
    }

    let fdate = event.fromdate ? event.fromdate : "";
    let tdate = event.todate ? event.todate : "";
    let participant_ref_number = event.participant_ref_number ? event.participant_ref_number : "";
    let consult_status = event.consult_status ? event.consult_status : "";
    let consult_id = event.consult_id ? event.consult_id : "";
    let searchkey = event.searchkey ? event.searchkey : "";
    let pageSize = event.pageSize ? event.pageSize : "";
    let pageIndex = event.pageIndex ? event.pageIndex : "";
    let active = event.active ? event.active : "";
    let direction = event.direction ? event.direction : "";

    let url =
      URLS.consult.getConsultsList +
      '?limit=' +
      pageSize +
      '&page=' +
      (pageIndex + 1) +
      '&searchkey=' +
      searchkey +
      '&order_by=' +
      active +
      '&dir=' +
      direction +
      '&from_date=' +
      fdate +
      '&to_date=' +
      tdate +
      '&participant_ref_number=' +
      participant_ref_number +
      '&consult_status=' +
      consult_status +
      '&consult_id=' +
      consult_id;
    return this.request.getApi(url);
  }

  getConsultsFullList(): Observable<any> {
    let url = URLS.consult.getConsultsFullList;
    return this.request.getApi(url);
  }


  ptzController(url: string): Observable<any> {
    return this.http.get(url, {});
  }


  checkContract(type: string): Observable<any> {
    let url = URLS.consult.checkContract;
    url = _.replace(url, '{type}', type);
    return this.request.getApi(url);
  }

  saveConsults(values): Observable<any> {
    let url = URLS.consult.saveConsults;
    return this.request.postApi(url, values);
  }

  getAutoCompleteConsultsList(val): Observable<any> {
    let url = URLS.consult.getConsultsFullList + '?searchkey=' + val;
    return this.request.getApi(url);
  }

  editConsults(id, values): Observable<any> {
    let url = URLS.consult.editDeleteConsults;
    url = _.replace(url, '{id}', id);
    return this.request.putApi(url, values);
  }

  deleteConsults(data): Observable<any> {
    let url = URLS.consult.editDeleteConsults;
    url = _.replace(url, '{id}', data.id);
    return this.request.deleteApi(url);
  }

  PatchConsults(data): Observable<any> {
    let url = URLS.consult.editDeleteConsults;
    url = _.replace(url, '{id}', data.consult_id);
    return this.request.patchApi(url, data);
  }

  getConsultsInfo(id): Observable<any> {
    let url = URLS.consult.editDeleteConsults;
    url = _.replace(url, '{id}', id);
    return this.request.getApi(url);
  }

  getConsultsInfo_byUserId(uid): Observable<any> {
    let url = URLS.consult.getConsultsList + '?user_id=' + uid;
    return this.request.getApi(url);
  }

  getConsultsSummary(consult_id: string): Observable<any> {
    let url = URLS.consult.getPatientsSummary + '?token=' + consult_id + '&pdf_for=consult_report';
    return this.request.getApi(url);
  }

  getPatientsSummary(consult_id: string, patient_id?: any, from?: any, to?: any): Observable<any> {
    let url = URLS.consult.getPatientsSummary + '?token=' + consult_id + '&from=' + from + '&to=' + to;
    if (patient_id > 0) {
      url = url + '&patient_id=' + patient_id;
    }
    return this.request.getApi(url);
  }

  getPatientsPdfSummary(consult_id: string, patient_id?: any, from?: Date, to?: Date): Observable<any> {
    let url = URLS.consult.getPatientsPdfSummary + '?token=' + consult_id + '&from=' + from + '&to=' + to;
    if (patient_id > 0) {
      url = url + '&patient_id=' + patient_id;
    }
    return this.request.getApi_documents(url);
  }

  getConsultsPdfSummary(consult_id: string): Observable<any> {
    let url = URLS.consult.getConsultsPdfSummary + '?token=' + consult_id;
    return this.request.getApi_documents(url);
  }

  getConsultStatusBadgeClassName(status: string): string {
    let status_class;

    switch (status) {
      case 'new':
        status_class = 'badge-primary';
        break;

      case 'pending':
        status_class = 'badge-info';
        break;

      case 'waiting':
      case 'resume':
      case 'started':
        status_class = 'badge-warning';
        break;

      case 'completed':
      case 'ended':
      case 'paid':
        status_class = 'badge-success';
        break;

      case 'cancelled':
      case 'unpaid':
      case 'expired':
        status_class = 'badge-danger';
        break;

      default:
        status_class = '';
        break;
    }

    return status_class;
  }
}
